import { LocationIcon } from 'components/icons/LocationIcon';
import { TicketIcon } from 'components/icons/TicketIcon';
import { useLanguage } from 'context/language.context';
import { format } from 'date-fns';
import { arSA, enUS } from 'date-fns/locale';
import { StringKey } from 'dictionaries/string-key.enum';
import { getFileUrl } from 'lib/utils';
import { FC } from 'react';
import { EventResponse } from 'types';

interface EventCardProps {
  event: EventResponse;
}

export const EventCard: FC<EventCardProps> = ({ event }) => {
  const { t, direction } = useLanguage();

  return (
    <div className="relative flex rounded-2xl border border-[#333333] overflow-hidden w-full">
      {event.bannerId ? (
        <img
          className="rounded-lg min-h-full w-[30%] object-cover object-center"
          src={getFileUrl(event.bannerId)}
          alt=""
        />
      ) : (
        <div className="rounded-lg min-h-full w-[30%] bg-gray-600" />
      )}
      <div className="flex flex-1 flex-col gap-2 p-3">
        <div className="flex flex-col gap-1">
          <p className="text-xs font-medium text-[#AA9CC9]">
            {format(event.startDate, 'MMM d • hh:mm a', {
              locale: direction === 'rtl' ? arSA : enUS,
            })}
          </p>
          <p className="font-semibold text-primary-white-1">{event.name}</p>
        </div>
        <div className="flex gap-1">
          <div className="flex justify-center min-w-5">
            <LocationIcon />
          </div>
          <p className="text-xs font-medium text-gray-600">{event.location || '-'}</p>
        </div>
        <div className="flex gap-1">
          <div className="flex justify-center min-w-5">
            <TicketIcon />
          </div>
          <p className="text-xs font-medium text-gray-600">
            {event.price ? `${t(StringKey.FROM)} SAR ${event.price.toFixed(2)}` : t(StringKey.FREE)}
          </p>
        </div>
      </div>
    </div>
  );
};
